import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api, formatApiErrorDetail } from "@/lib/api";
import { formatFullWIB } from "@/lib/datetime";
import { LABEL_AKSI_RIWAYAT, teksRingkasanRiwayat } from "@/lib/surveiEditor";

// Riwayat revisi satu versi (ringkasan angka, waktu, pelaku). "Pulihkan" hanya utk draf & bila tidak ada perubahan
// belum disimpan (pemulihan menulis ulang isi draf di server dgn rev baru).
export default function SurveiRiwayatVersi({ open, versiId, revSekarang, bolehPulihkan, onTutup, onPulihkan }) {
    const [daftar, setDaftar] = useState(null);
    const [galat, setGalat] = useState("");
    useEffect(() => {
        if (!open) return;
        setDaftar(null); setGalat("");
        api.get(`/survei/versi-butir/${versiId}/riwayat`)
            .then((r) => setDaftar(r.data.riwayat))
            .catch((e) => setGalat(formatApiErrorDetail(e.response?.data?.detail)));
    }, [open, versiId]);
    return (
        <Dialog open={open} onOpenChange={(o) => !o && onTutup()}>
            <DialogContent className="max-h-[90vh] max-w-2xl overflow-y-auto">
                <DialogHeader>
                    <DialogTitle>Riwayat revisi</DialogTitle>
                    <DialogDescription>Setiap simpan tercatat (maksimal 100 revisi terakhir). Ringkasan hanya angka.</DialogDescription>
                </DialogHeader>
                {galat && <p role="alert" className="text-sm text-rose-700">{galat}</p>}
                {!daftar && !galat && <p className="text-sm text-slate-500">Memuat…</p>}
                {daftar && (
                    <ul className="divide-y divide-slate-200 text-sm" data-testid="survei-riwayat-daftar">
                        {daftar.map((r) => (
                            <li key={r.rev} className="flex flex-wrap items-center justify-between gap-2 py-2">
                                <div>
                                    <div className="font-semibold">Rev {r.rev} · {LABEL_AKSI_RIWAYAT[r.aksi] || r.aksi}</div>
                                    <div className="text-xs text-slate-500">{formatFullWIB(r.waktu)} · {r.oleh}</div>
                                    <div className="text-xs text-slate-600">{teksRingkasanRiwayat(r.ringkasan)}</div>
                                </div>
                                {bolehPulihkan && r.rev !== revSekarang && (
                                    <Button size="sm" variant="outline" onClick={() => onPulihkan(r.rev)} data-testid={`survei-pulihkan-${r.rev}`}>Pulihkan</Button>
                                )}
                            </li>
                        ))}
                    </ul>
                )}
            </DialogContent>
        </Dialog>
    );
}
